import script from "./RowDetailDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./RowDetailDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./datastoreDrawers.scss?vue&type=style&index=0&id=552ef8a0&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-552ef8a0"]])

export default __exports__